<template>
    <app-layout title="Gebruikers">
        <template #header>
            <page-title title="Gebruiker wijzigen" />
        </template>

        <template #pageContent>
            <Form layout="columns" @submit="updateUser">
                <div>
                    <Input label="Gebruikersnaam" name="username" v-model="user_info.username" disabled layout="vertical"/>
                    <Input label="Voornaam + achternaam" name="name" type="text"  v-model="form.name" required :error="form.errors.name" layout="vertical"/>
                    <Input label="Email" name="email" type="text" v-model="form.email" required :error="form.errors.email" layout="vertical"/>
                    <Input label="Functie" name="function" type="text"  v-model="form.function" :error="form.errors.function" required layout="vertical"/>
                    <Textarea label="Opmerking" name="comment" type="text"  v-model="form.comment" :error="form.errors.comment" layout="vertical" :maxlength="255"/>
                </div>
                <div class="flex flex-col">
                    <div class="pt-1.5">
                        <Label for="roles" label="Rollen" class="flex-none" id="label_roles"></Label>
                        <Multiselect
                            v-model="form.roles"
                            :options="roles"
                            mode="tags"
                            id="roles"
                            :searchable="true"
                            placeholder="selecteer een rol"
                            :closeOnSelect="false"
                        />
                        <Error :error="form.errors.roles" v-if="form.errors.roles" />
                    </div>

                    <div class="mt-3">
                        <Label for="permissions" label="Rechten" class="flex-none" id="label_permissions"/>
                        <Multiselect
                            v-model="form.permissions"
                            :options="permissions"
                            mode="tags"
                            id="permissions"
                            :searchable="true"
                            placeholder="selecteer een recht"
                            :closeOnSelect="false"
                        />
                        <Error :error="form.errors.permissions" v-if="form.errors.permissions" />
                    </div>

                    <div class="mt-3">
                        <Input label="In dienst op" name="activate_on" v-model="form.activate_on" layout="vertical" type="date"/>
                        <Input label="Uit dienst op" name="deactivate_on" v-model="form.deactivate_on" layout="vertical" type="date"/>
                    </div>



                    <div class="flex mt-auto flex-wrap justify-end">
                        <Button
                            htmlType="a"
                            buttonClass="cancel"
                            title="Annuleren"
                            text="Annuleren"
                            :href="route('admin.users.show',{'user': user_info.id})"
                        />
                        <Button text="Gebruiker aanpassen" buttonType="submit" buttonClass="save"/>
                    </div>

                </div>
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Button from '@/Components/Button.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'
import Form from '@/Components/Form.vue'
import InputGroup from '@/Components/InputGroup.vue'
import Label from '@/Components/Label.vue'
import Error from '@/Components/Error.vue'
import Textarea from '@/Components/Textarea.vue'

import { useForm } from '@inertiajs/inertia-vue3';
import store from '@/store'
import moment from "moment";
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Input,
        Select,
        Form,
        Multiselect,
        InputGroup,
        Label,
        Error,
        Textarea
    },
    props:[
        'roles',
        'permissions',
        'user_info'
    ],
    data() {
        return {}
    },
    setup (props){
        let form = useForm({
            name: props.user_info.name,
            username: props.user_info.username,
            email: props.user_info.email,
            function: props.user_info.function,
            comment: props.user_info.comment,
            activate_on: props.user_info.activate_on,
            deactivate_on: props.user_info.deactivate_on,
            roles: props.user_info.role_ids,
            permissions: props.user_info.permissions,
        })

        function updateUser(){
            form.put('/admin/users/' + props.user_info.id)
        }

        return {
            state: store.state,
            ...store,
            form,
            updateUser
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
    },
}

</script>
